import React, { useEffect, useState } from "react";
import { useAtomValue } from "jotai";
import { WrappedRCEMessageBox } from "./wrapped/WrappedRCEMessageBox";
import { chatbotConfigState } from "../../state/config/ChatbotConfigState";
import { useAppTranslation } from "../../hooks/useAppTranslation";

export function BotAnswerAnimation() {
    const [dots, setDots] = useState(1);
    const MAX_DOTS = 3;
    const MIN_DOTS = 1;

    const config = useAtomValue(chatbotConfigState);
    const { t } = useAppTranslation();

    useEffect(() => {
        const interval = setInterval(() => {
            setDots((prev) => (prev < MAX_DOTS ? prev + 1 : MIN_DOTS));
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    function displayDots(count) {
        return '.\u00A0'.repeat(count).padEnd(MAX_DOTS * 2, '\u00A0');
    }

    const thinkingText = (t?.thinkingEllipsis || "Thinking…")
        .replace("…", "")
        .trim();

    return (
        <WrappedRCEMessageBox
            position={"left"}
            text={`${thinkingText} ${displayDots(dots)}`}
            title={config?.chatbotName || "Assistant"}
        />
    );
}